import PropTypes from "prop-types";
import './DishHeader.scss';

const DishHeader = ({expanded, name}) => (
    <div className={`dish-header ${expanded ? 'dish-header--expanded' : ''}`}>
        {name}
    </div>
);

DishHeader.propTypes = {
    name: PropTypes.string,
    expanded: PropTypes.bool
};

export default DishHeader;
